import { useState } from "react";
import {
    Button,
    TextField,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    FormControl,
    MenuItem,
    InputLabel,
    Select,
    Grid,
    Typography,
    IconButton,
} from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";

function FilterAllBotModel({
    open,
    searchParams,
    setSearchParams,
    handleClickOpenModel,
    handleCloseFilterModel,
    handleClickSearch,
}) {

    const [search, setSearch] = useState(searchParams);

    const handleChange = (e) => {
        const value = e.target.value;
        const name = e.target.name;
        setSearch({ ...search, [name]: value });
    };
    const botStatus = [
        "new",
        "development",
        "verification_in_process",
        "verified",
        "verification_submitted",
        "launching_in_process",
        "launched",
        "suspended"
    ];

    const botMessageType = [
        "OTP",
        "PROMOTIONAL",
        "Transactional",
    ];
    const onClickClear = () => {
        setSearchParams({
            botName: "",
            brandName: "",
            // clientName: "",
            botMessageType: "",
            status: "",
        });

        handleClickSearch({
            botName: "",
            brandName: "",
            // clientName: "",
            botMessageType: "",
            status: "",
        })
    };
    return (
        <>
            <Dialog
                open={open}
                onClose={handleCloseFilterModel}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <Typography variant="h5"> Bots List Filter</Typography>
                    <IconButton onClick={() => handleCloseFilterModel()}>
                        <CloseOutlined />
                    </IconButton>
                </DialogTitle>
                <Divider />
                <DialogContent
                    sx={{
                        overflowY: "hidden",
                        display: "flex",
                        flexDirection: "column",
                        gap: "30px",
                        width: "500px",
                    }}
                >
                    <Grid container fullWidth justifyContent={"space-between"}>
                        <Grid item md={5.5}>
                            <TextField
                                value={search.botName}
                                name="botName"
                                onChange={handleChange}
                                label="Bot Name"
                                fullWidth
                                placeholder=" Enter Bot Name"
                            />
                        </Grid>
                        <Grid item md={5.5}>
                            <TextField
                                value={search.brandName}
                                name="brandName"
                                onChange={handleChange}
                                label="Brand Name"
                                fullWidth
                                placeholder=" Enter Brand Name"
                            />
                        </Grid>
                    </Grid>
                    <Grid container fullWidth justifyContent={"space-between"}>
                        {/* <Grid item md={5.5}>
                            <TextField
                                value={search.clientName}
                                name="clientName"
                                onChange={handleChange}
                                label="Client Name"
                                fullWidth
                                placeholder=" Enter Client Name"
                            />
                        </Grid> */}
                        <Grid item md={5.5}>
                            <FormControl fullWidth>
                                <InputLabel id="demo-controlled-open-select-label">
                                    Bot Message Type
                                </InputLabel>
                                <Select
                                    labelId="demo-controlled-open-select-label"
                                    id="demo-controlled-open-select"
                                    name="botMessageType"
                                    value={search.botMessageType}
                                    label="Bot Message Type"
                                    onChange={handleChange}
                                >
                                    {botMessageType.map((botMessageType) => (
                                        <MenuItem value={botMessageType}>
                                            {botMessageType.toLocaleUpperCase()}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item md={5.5}>
                            <FormControl fullWidth>
                                <InputLabel id="demo-controlled-open-select-label">
                                    Status
                                </InputLabel>
                                <Select
                                    labelId="demo-controlled-open-select-label"
                                    id="demo-controlled-open-select"
                                    name="status"
                                    value={search.status}
                                    label="Status"
                                    onChange={handleChange}
                                >
                                    {botStatus.map((status) => (
                                        <MenuItem value={status}>
                                            {status.replaceAll("_", " ").toLocaleUpperCase()}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions
                    style={{
                        padding: "1rem 1.5rem",
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: ".25rem",
                    }}
                >
                    <Button
                        variant="contained"
                        color="error"
                        onClick={() => onClickClear()}
                    >
                        Clear
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => handleClickSearch(search)}
                        autoFocus
                    >
                        Search
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default FilterAllBotModel;
